export const ProgProdCalcValueCellRenderer = ({ value, colDef, data }) => {
  const PCT_CALC_TYPES = ['PCT_OFF', 'MAX_ALLOWED_PCT'];
  // CalcProdPp/CalcProdRes also carry calcId (Calc is their composite root), so check the more specific fields first

  if (PCT_CALC_TYPES.includes(data.progProdCalcType)) {
    value = data.value * 100 + '%';
  } else if (value >= 0) {
    value = '$' + data.value;
  } else {
    value = '-$' + data.value;
  }

  return <span>{value}</span>;
};
